import { css } from 'emotion'

export const AdminMainStyles = css`
  > ul > li {
    margin: 16px;
  }
`
